import request from 'utils/request'

// 分页接口 page页面
export const getTableData = params =>
  request().post('bureau-report/page', params)

//权限
export const getCustomerOverview = id => request().get(`customer/query/${id}`)

// 获取 City、Country、Region、Business、CCA、Document Type、File Language， 参数 typeMark 传以上字段
export const getSelectList = params => {
  if (typeof params === 'string') params = { typeMark: params }
  return request().post('valuelist/getValueList', params)
}
